export function formatOverrideCurrency(v: number | null | undefined): string {
  if (v == null) return '—';
  return `$${v.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatOverrideNumber(v: number | null | undefined): string {
  if (v == null) return '—';
  return v.toLocaleString();
}
